module.exports = __webpack_public_path__ + "img/target-01.2b63a773.svg";